export default "__VITE_ASSET__DqjU826x__"